import script from "./BranchAdminNotice.vue?vue&type=script&setup=true&lang=ts"
export * from "./BranchAdminNotice.vue?vue&type=script&setup=true&lang=ts"

import "./BranchAdminNotice.vue?vue&type=style&index=0&id=0d3569f2&lang=css"

const __exports__ = script;

export default __exports__